import { merge } from 'lodash';
import getBackground from 'nucleus-widgets/utils/style/getBackground';
import clearImageInTheme from './clearImageInTheme';
import { createSelector } from 'reselect';
export default createSelector(state => state.website.theme.global, state => state.website.theme.sections, (global, sections) => {
    const { dialog: customDialogStyles } = global;
    let customSettings;
    if (customDialogStyles) {
        customSettings = {
            background: Object.assign(Object.assign({}, customDialogStyles.background), customDialogStyles.body.background)
        };
    }
    const style = Object.assign(Object.assign({}, clearImageInTheme(merge({}, global, sections.content1))), { styleMapping: 'custom', customSettings: customSettings || {} });
    return getBackground(style, style.customSettings, style.palette);
});
